import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import { ArrowBackCircle } from "react-ionicons";
import constantURI from "../URI";
import _post from "../Functions/Post";
import SearchFilterFunction from "../Functions/SearchFilter";
import stylesASAP from "./stylesASAP";
import ASAPAuthenticate from "../Functions/ASAPAuthenticate";
import stylesMed from "../MedRep/stylesMed";
import { db, getDocs, collection, disableNetwork } from "../firebase";
import { set, get } from "idb-keyval";
import normalizeUnsyncedTransactions from "../Functions/normalizeUnsyncedTransactions";

export default class TransactionDetailASAP extends React.Component {
  constructor() {
    super();
    this.state = {
      SOLs: [],
      SOLsCopy: [],
      loading: true,
      noData: true,
      orderId: 0,
      orderDetail: [],
      token: "",
      authenticate: false,
      allitems: [],
      alertUndefined: false,
      selectedclient: 0,
      VAT: "",
      Total: "",
      unsycJournal: 1,
      transactionTypes: [
        {
          id: 0,
          name: "Order",
          SOLs: "GetSOLs?token=",
          LS: "OrderLines",
          type: "Sales",
        },
        {
          id: 1,
          name: "Return",
          SOLs: "GetSOLs?token=",
          LS: "OrderLines",
          type: "Return",
        },
        {
          id: 2,
          name: "Purchase",
          SOLs: "GetPOLs?token=",
          LS: "PurchaseLines",
        },
        { id: 3, name: "Invoices", SOLs: "", LS: "InvoicesLines" },
        {
          id: 4,
          name: "Delivery",
          SOLs: "GetSOLs?token=",
          LS: "DeliveryLines",
        },
        {
          id: 5,
          name: "CashSales",
          SOLs: "GetSOLs?token=",
          LS: "OrderLines",
          type: "CashSales",
        },
      ],
      currentType: 1,
      username: "",
      isDraft: (() => {
        try {
          return JSON.parse(localStorage.getItem("CurrentTab") || "[{ isDraft: false }]")[0].isDraft;
        } catch (error) {
          return false;
        }
      })(),
    };
  }

  async componentDidMount() {
    document.body.style.backgroundColor = "#e6e6fa";
    this.setState({ username: JSON.parse(localStorage.getItem("Username")) });

    const type = localStorage.getItem("TransactionType");
    if (Number(type) === 2) {
      await this.setState({
        ...(this.state.transactionTypes[4].SOLs = "GetPOLs?token="),
      });
    }
    const isDelivery = JSON.parse(localStorage.getItem("IsDelivery"));
    if (isDelivery) await this.setState({ currentType: 4 });
    else await this.setState({ currentType: JSON.parse(type) });
    // await ASAPAuthenticate().then((response) => {
    //     this.setState({authenticate: response})
    // });
    const token = localStorage.getItem("Token");
    const orderId = localStorage.getItem("OrderId");
    const usOrderId = (() => {
      try {
        return JSON.parse(localStorage.getItem("USOrderId"));
      } catch (error) {
        return undefined;
      }
    })();
    const selectedclient = (() => {
      try {
        return JSON.parse(localStorage.getItem("SelectedClient"));
      } catch (error) {
        return undefined;
      }
    })();
    const unsycJournal = (() => {
      try {
        return JSON.parse(localStorage.getItem("unsycJournal"));
      } catch (error) {
        return undefined;
      }
    })();
    const settingArray = (() => {
      try {
        return JSON.parse(localStorage.getItem("SettingArray") || "[]");
      } catch (error) {
        return [];
      }
    })();
    await this.setState({
      token: JSON.parse(token),
      selectedclient: selectedclient,
      unsycJournal: unsycJournal,
      settingArray: Array.isArray(settingArray) ? settingArray : [],
    });

    const { transactions: unsyncedTransactions } =
      normalizeUnsyncedTransactions();
    const currentCashSalesName = (() => {
      try {
        return JSON.parse(localStorage.getItem("CurrentCashSales") || "null");
      } catch (error) {
        return null;
      }
    })();
    const storedOrderId = (() => {
      try {
        return JSON.parse(localStorage.getItem("OrderId") || "null");
      } catch (error) {
        return localStorage.getItem("OrderId");
      }
    })();
    const candidateKeys = [
      currentCashSalesName,
      storedOrderId,
      orderId,
      usOrderId,
      Number(storedOrderId),
      Number(orderId),
      Number(usOrderId),
    ].filter((value) => value !== null && value !== undefined && value !== "undefined");

    const matchingUnsyncedOrders = (unsyncedTransactions?.[this.state.currentType] || []).filter((item) => {
      if (usOrderId !== undefined && usOrderId !== null) {
        const matchesUsOrder =
          item?.usId === Number(usOrderId) ||
          item?.id === Number(usOrderId) ||
          item?.usId === usOrderId;
        if (matchesUsOrder) return true;
      }

      if (storedOrderId !== null && storedOrderId !== undefined && storedOrderId !== "undefined") {
        const matchesStoredOrder =
          item?.name === storedOrderId ||
          item?.Body?.name === storedOrderId ||
          item?.Body?.invoice_name === storedOrderId ||
          item?.Body?.cashInvoiceName === storedOrderId ||
          item?.usId === Number(storedOrderId) ||
          item?.id === Number(storedOrderId);
        if (matchesStoredOrder) return true;
      }

      return candidateKeys.some((key) => {
        const normalizedKey = typeof key === "string" ? key.trim() : key;
        if (normalizedKey === "" || normalizedKey === null || normalizedKey === undefined) {
          return false;
        }

        return (
          item?.name === normalizedKey ||
          item?.Body?.name === normalizedKey ||
          item?.Body?.invoice_name === normalizedKey ||
          item?.Body?.cashInvoiceName === normalizedKey ||
          item?.usId === Number(normalizedKey) ||
          item?.id === Number(normalizedKey)
        );
      });
    });

    const unsyncedOrder =
      matchingUnsyncedOrders.length > 1
        ? matchingUnsyncedOrders.find((item) => {
            const normalizedCurrentCashSales =
              typeof currentCashSalesName === "string" ? currentCashSalesName.trim() : currentCashSalesName;
            return (
              item?.name === normalizedCurrentCashSales ||
              item?.Body?.name === normalizedCurrentCashSales ||
              item?.Body?.invoice_name === normalizedCurrentCashSales ||
              item?.Body?.cashInvoiceName === normalizedCurrentCashSales ||
              item?.usId === Number(normalizedCurrentCashSales) ||
              item?.id === Number(normalizedCurrentCashSales)
            );
          }) || null
        : matchingUnsyncedOrders[0] || null;

    if (unsyncedOrder) {
      this.setState({
        orderDetail: unsyncedOrder,
      });
      await this.setState({
        SOLs: unsyncedOrder?.Lines || [],
        Total: unsyncedOrder?.amount_total || 0,
        VAT: unsyncedOrder?.VAT || 0,
        loading: false,
      });
    } else {
      this.setState({ orderId: JSON.parse(localStorage.getItem("OrderId")) });

      // if (this.state.authenticate) {
      //     _post(getSOLs).then((response) => {
      //         return response.json().then((data) => {
      //             if (data.result !== undefined) {
      //                 this.setState({allitems: data.result});
      //                 localStorage.setItem(this.state.transactionTypes[this.state.currentType].LS, JSON.stringify(this.state.allitems));
      //                 var tempOn = [];
      //                 this.state.allitems.forEach((item) => {
      //                     if (item.order_id[0] === this.state.orderId) {
      //                         tempOn.push(item);
      //                     }
      //                 })
      //                 this.setState({SOLs: tempOn, SOLsCopy: tempOn, loading: false});
      //             } else {
      //                 this.setState({alertUndefined: true});
      //             }
      //         })
      //     })
      // } else {

      await this.readDataLine();

      //const clients = localStorage.getItem(this.state.transactionTypes[this.state.currentType].LS);
      //this.setState({ allitems: JSON.parse(clients) });
      var tempOff = [];
      this.state.allitems.forEach((item) => {
        if (item.order_id[0] === this.state.orderId) {
          tempOff.push(item);
        }
      });
      await this.setState({ SOLs: tempOff, SOLsCopy: tempOff, loading: false });
      console.log(this.state.SOLs);
    }
    await this.readData();
  }
  readData = async () => {
    try {
      // Use 'get' method from idb-keyval to read Clients from IndexedDB
      const data = await get("Clients");

      if (data) {
        this.setState({ clients: data, loading: false });
        console.log("Clients from IndexedDB:", data);
        const clientIdToQuery = this.state.selectedclient; // Replace with the actual clientId you want to query
        const queriedClient = data.find(
          (client) => client.id === clientIdToQuery
        );
        this.setState({ clientDetail: queriedClient });
      } else {
        console.log("Clients not found in IndexedDB.");
      }
    } catch (error) {
      console.error("Error reading Clients from IndexedDB:", error);
    }
  };
  readDataLine = async () => {
    try {
      // Use 'get' method from idb-keyval to read Orders or purchase from IndexedDB Dynamic
      const data = await get(
        this.state.transactionTypes[this.state.currentType].LS
      );

      if (data) {
        this.setState({ allitems: data });
        console.log(this.state.allitems);
        console.log("orderLine from IndexedDB:", data);
      } else {
        console.log("orderLine not found in IndexedDB.");
      }
    } catch (error) {
      console.error("Error reading orderLine from IndexedDB:", error);
    }
  };
  // readDataLine = async () => {
  //     const querySnapshot = await getDocs(collection(db, "OrderLines"));
  //     const transactionLines = querySnapshot.docs.map((doc) => ({
  //         id: doc.id,
  //         ...doc.data()
  //     }));
  //     this.setState({allitems: transactionLines, loading: false})
  // }

  onSearch = async (text) => {
    var values = await SearchFilterFunction(
      text,
      this.state.SOLs,
      this.state.SOLsCopy,
      this.state.noData
    );
    this.setState({ SOLs: values.items, noData: values.noData });
  };

  onClickEdit = () => {
    this.props.history.push("./Items");
    localStorage.setItem("CatalogId", JSON.stringify(1));
    localStorage.setItem("isEdit", JSON.stringify(this.state.orderDetail));
  };

  render() {
    const isReceiptView = this.state.currentType === 3;
    const solRows = Array.isArray(this.state.SOLs) ? this.state.SOLs : [];
    const paymentSourceCandidates = [
      this.state.orderDetail?.Body?.cashPayment,
      this.state.orderDetail?.cashPayment,
      this.state.orderDetail?.Body?.lines,
      this.state.orderDetail?.lines,
      this.state.orderDetail?.Body?.payments,
      this.state.orderDetail?.payments,
      this.state.orderDetail?.Body?.payment,
      this.state.orderDetail?.payment,
    ];
    const cashSalesPaymentRows = paymentSourceCandidates
      .flatMap((source) => (Array.isArray(source) ? source : []))
      .filter((payment) => {
        if (!payment || typeof payment !== "object") return false;
        return (
          payment?.payment_type !== undefined ||
          payment?.paymentType !== undefined ||
          payment?.payment_type_id !== undefined ||
          payment?.receipt_amount !== undefined ||
          payment?.amount !== undefined
        );
      });
    const orderPartnerName =
      this.state.orderId !== 0
        ? this.state.SOLs?.[0]?.order_partner_id?.[1]
        : this.state.orderDetail?.partner_id?.[1] ??
          this.state.SOLs?.[0]?.order_partner_id?.[1] ??
          "";
    const orderDate =
      this.state.orderId !== 0
        ? this.state.SOLs?.[0]?.create_date
        : this.state.orderDetail?.date_order ?? "";

    console.log(this.state.selectedclient);
    console.log(this.state.clientDetail);
    console.log(this.state.SOLs);
    return (
      <div
        className="container-fluid vh-100"
        style={stylesASAP.mainBackgroundColor}
      >
        {!this.state.alertUndefined ? null : (
          <div className="col alert alert-danger">
            <div className="row">
              <h6 className="col-sm-8">There seems to be a problem.</h6>
              <div className="col d-flex flex-row-reverse">
                <div
                  className="btn"
                  style={stylesMed.wideButton}
                  onClick={() => window.location.reload()}
                >
                  Reload
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="pt-3 row">
          <div className="col">
            <ArrowBackCircle
              className="btn col"
              onClick={() => this.props.history.goBack()}
              color={"#65a0ff"}
              height="50px"
              width="50px"
            />
          </div>
          
          {Array.isArray(this.state.settingArray)
            ? this.state.settingArray.map((st, index) =>
                st.key === "EnableEditTransaction" && st.value === "1" ? (
                  this.state.orderId === 0 ? (
                    <div
                      key={st.key + "-" + index}
                      className="col d-flex flex-row-reverse"
                      style={
                        this.state.currentType === 3 && !this.state.isChecked
                          ? stylesASAP.disable
                          : null
                      }
                    >
                      {this.state.unsycJournal === 1 && this.state.currentType !== 5 && this.state.isDraft ? (
                        <div
                          key={"edit-action-" + index}
                          className="col-sm-4 btn"
                          onClick={() => this.onClickEdit()}
                          style={stylesASAP.soButton}
                        >
                          Edit{" "}
                          {this.state.currentType !== -1
                            ? this.state.transactionTypes[this.state.currentType]
                                .name
                            : null}
                        </div>
                      ) : null}
                    </div>
                  ) : null
                ) : null
              )
            : null}
        </div>
        {/* <div className="pt-3">
          <input
            type="text"
            className="form-control"
            placeholder="Search Here"
            onChange={(text) => this.onSearch(text)}
          />
        </div> */}
        <p className="pt-3 text-center h3">
          {this.state.transactionTypes[this.state.currentType].type} Order
          Detail
        </p>

        <div className="card mt-5">
          <div className="row">
            <div className="row m-1">
              <h5 className="col-sm-4 ">Client</h5>
              <h5 className="col-sm-4">Date</h5>
              <h5 className="col-sm-2 ">VAT</h5>
              <h5 className="col-sm-2">Total</h5>
              {this.state.loading && this.state.orderId !== 0 ? (
                <div className="card-body text-center">
                  <div
                    className="spinner-border"
                    style={stylesASAP.spinner}
                  ></div>
                </div>
              ) : (
                <div className="pt-3">
                  <div className="bg-light">
                    <div className="row ">
                      <div className="col-sm-4">{orderPartnerName}</div>

                      <div className="col-sm-4">{orderDate}</div>
                      <div className="col-sm-2">{this.state.VAT}</div>
                      <div className="col-sm-2">{this.state.Total}</div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="card mt-3 ">
          <div className="row m-1">
            {isReceiptView ? (
              <>
                <h5 className="col-sm-3">Payment Type</h5>
                <h5 className="col-sm-3">Amount</h5>
                <h5 className="col-sm-3">Receipt Amount</h5>
                <h5 className="col-sm-3">Reference</h5>
              </>
            ) : (
              <>
                <h5 className="col-sm-3">Item name</h5>
                <h5 className="col-sm-3">Qty</h5>
                <h5 className="col-sm-3">Disc%</h5>
                <h5 className="col-sm-3">Total</h5>
              </>
            )}
          </div>
          {this.state.loading ? (
            <div className="card-body text-center">
              <div className="spinner-border" style={stylesASAP.spinner}></div>
            </div>
          ) : (
            solRows.map((item, index) => {
              const rowKey =
                item?.id ?? item?.receiptNum ?? item?.product_id ?? item?.name ?? `line-${index}`;
              return (
                <div className="pt-3" key={rowKey}>
                  <div className="bg-light">
                    <div className="row m-1">
                      {isReceiptView ? (
                        <>
                          <div className="col-sm-3">
                            {item.payment_type || item.paymentType || item.name || `Payment ${index + 1}`}
                          </div>
                          <div className="col-sm-3">
                            {item.amount !== undefined ? item.amount : item.receipt_amount ?? 0}
                          </div>
                          <div className="col-sm-3">
                            {item.receipt_amount !== undefined ? item.receipt_amount : item.amount ?? 0}
                          </div>
                          <div className="col-sm-3">
                            {item.valueDate || item.invoice_date || item.receiptNum || item.id || "-"}
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="col-sm-3">{item.name}</div>
                          {item.freeItem !== undefined ? (
                            item.product_uom_qty !== undefined ? (
                              <div className="col-sm-3">
                                {item.product_uom_qty + " " + "(" + item.freeItem}{" "}
                                <span class="badge rounded-pill bg-secondary">
                                  free{" "}
                                </span>{" "}
                                {")"}
                              </div>
                            ) : (
                              <div className="col-sm-3">
                                {"0" + " " + "(" + item.freeItem}{" "}
                                <span class="badge rounded-pill bg-secondary">
                                  free{" "}
                                </span>{" "}
                                {")"}
                              </div>
                            )
                          ) : (
                            <div className="col-sm-3">{item.product_uom_qty}</div>
                          )}

                          <div className="col-sm-3">
                            {item.discount === undefined ? 0 : item.discount}%
                          </div>
                          <div className="col-sm-3">
                            {item.price_total === undefined ? 0 : item.price_total}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              );
            })
          )}
          {/* {this.state.loading && this.state.orderId !== 0 ? (
            <div className="card-body text-center">
              <div className="spinner-border" style={stylesASAP.spinner}></div>
            </div>
          ) : (
            <div className="pt-3">
              <div className="bg-light">
                <div className="row">
                  <div className="col-sm-3">
                    {this.state.orderId !== 0
                      ? this.state.SOLs[0].order_id[0]
                      : null}
                  </div>
                  <div className="col-sm-3">
                    {this.state.orderId !== 0
                      ? this.state.SOLs[0].create_date
                      : this.state.orderDetail.date_order}
                  </div>
                  <div className="col-sm-3">
                    {this.state.orderId !== 0
                      ? this.state.SOLs[0].order_partner_id[1]
                      : this.state.orderDetail.partner_id !== undefined
                      ? this.state.orderDetail.partner_id[1]
                      : null}
                  </div>

                  <div className="col-sm-3">
                    {this.state.clientDetail !== undefined
                      ? this.state.clientDetail.currency_id[1]
                      : ""}
                  </div>
                </div>
              </div>
            </div>
          )} */}
        </div>
        {this.state.transactionTypes[this.state.currentType].id === 5 ? (
          <div className="card mt-4 m-1">
            <div className="row m-1">
              <h5 className="col-sm-6">Payment Type</h5>
              <h5 className="col-sm-6">Amount</h5>
            </div>

            {cashSalesPaymentRows.length > 0 ? (
              cashSalesPaymentRows.map((payment, index) => (
                <div className="pt-3" key={payment?.payment_type || payment?.paymentType || payment?.payment_type_id || `cash-payment-${index}`}>
                  <div className="bg-light">
                    <div className="row m-1">
                      <div className="col-sm-6">
                        {payment?.payment_type || payment?.paymentType || payment?.name || `Payment ${index + 1}`}
                      </div>
                      <div className="col-sm-6">
                        {payment?.amount ?? payment?.receipt_amount ?? 0}
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="pt-3">
                <div className="bg-light">
                  <div className="row m-1">
                    <div className="col-sm-12 text-muted">No payment data recorded</div>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : null}
      </div>
    );
  }
}
